import { EnumListType } from "gql/generated.ts";
import i18n from "i18next";

export const getTagPropsFromCustomListType = (type: EnumListType) => {
  /* TODO: add "visual" for unknown mappings. Have already asked Olivier */
  switch (type) {
    case EnumListType.Manual:
      return {
        visual: "warning",
        mode: "light",
        children: i18n.t(`customLists:PAGE.LIST_TYPE.${type}`),
      };
    case EnumListType.Smart:
      return {
        visual: "accent.blue",
        mode: "light",
        children: i18n.t(`customLists:PAGE.LIST_TYPE.${type}`),
      };
  }
};
